import React from 'react';
import { observer } from 'mobx-react';
import FolderClosed16 from '@honeybook/icons/dist/icons/FolderClosed16';
import colors from '@honeybook/hbui/dist/styles/colors';
import ArrowRight16 from '@honeybook/icons/dist/icons/ArrowRight16';
import styled from 'styled-components';
import {
    TemplatesList,
    TemplatesListItem,
    TemplatesListItemContainer
} from '../StepSideBar/StepSideBar.styles';
import { TTemplatePanel } from '../../../../Templates/types/templates.types';
import useAnalytics from '../../../../../common/useAnalytics';
import { AnalyticsEvents } from '../../../../../services/analytics/analytics-events';
import { IFolder } from '../../../../../types/model.types';
import { useRootStore } from '~/stores/useRootStore';
import { useGetMenuList } from '~/components/Templates/components/TemplatesSidebar/FlowsMenu/useGetMenuList';

const FolderSelect = () => {
    const {
        templatesCtrl,
        automationUiStore: { setSelectedAutomationSidebarScreen },
        templatesUiStore: { sortedCompanyFolders }
    } = useRootStore();
    const { menuList } = useGetMenuList();
    const { track } = useAnalytics();

    const onPanelSelect = (panel: TTemplatePanel) => {
        templatesCtrl.setActiveFlowPanel({ panel });
        onSelect(panel);
    };

    const onFolderSelect = (folder: IFolder) => {
        templatesCtrl.setActiveFolderPanel({ folderId: folder._id });
        onSelect(folder.path);
    };

    const onSelect = (folderName: string) => {
        setSelectedAutomationSidebarScreen('selectFile');
        track(AnalyticsEvents.AutomationsSideBarActionFolder, {
            action: 'click',
            folder_name: folderName
        });
    };

    return (
        <TemplatesList>
            {menuList.map(item => (
                <Container
                    key={item.label}
                    onClick={() => onPanelSelect(item.section)}
                >
                    <item.icon color={colors.neutral800} />
                    <TemplatesListItem>{item.label}</TemplatesListItem>
                    <ArrowRight16 />
                </Container>
            ))}
            {sortedCompanyFolders.map(folder => (
                <Container
                    key={folder._id}
                    onClick={() => onFolderSelect(folder)}
                >
                    <FolderClosed16 color={colors.neutral800} />
                    <TemplatesListItem>{folder.path}</TemplatesListItem>
                    <ArrowRight16 />
                </Container>
            ))}
        </TemplatesList>
    );
};
export default observer(FolderSelect);

// -------------------------------- Styles -------------------------------- //

const Container = styled(TemplatesListItemContainer)`
    gap: 9px;
    &:hover {
        svg * {
            fill: ${colors.neutral800};
        }
    }
`;
